import { SimpleGrid, Skeleton, Stack } from '@backyard-ui/core'

const SKELETON_HEIGHT = '358px'
const SKELETON_COUNT = 8

export function Loading() {
  return (
    <Stack align="center" direction="column">
      <SimpleGrid
        columns={{
          initial: 2,
          sm: 3,
          md: 4
        }}>
        {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
          <Skeleton
            key={`skeleton-${index}`}
            width="100%"
            height={SKELETON_HEIGHT}
          />
        ))}
      </SimpleGrid>
    </Stack>
  )
}
